// src/components/MapView.tsx
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import '../../libs/leafletIconFix';
import { AccomodationFirstChildren } from '@models/accomodation-first-children.model';
import { useEffect, useState } from 'react';
import { useSpinner } from './SpinnerContext';
import accomodationService from "@services/accomodation.service";
import sessionStorageService from '@services/sessionStorage.service';
import { useLocation } from 'react-router-dom';
import { Location } from '@models/location.model';

export default function MapView() {
  const [location, setLocation] = useState<Location | undefined>(undefined);
  const { showSpinner, hideSpinner } = useSpinner();
  const loc = useLocation();

  useEffect(() => {
    async function getHomePageData(accomodationIdQrCode: string) {
      try {
        showSpinner()
        const response = await accomodationService.getLocation(accomodationIdQrCode)
        sessionStorage.setItem('location', JSON.stringify(response));
        setLocation(response)
      } catch (error) {
        console.log(error);
      } finally {
        hideSpinner()
      }
    }

    const cached = sessionStorageService.getLocationSS();

    if (cached) {
      setLocation(cached);
    } else {
      const qrCodeId = loc.pathname.split("/")[1];
      getHomePageData(qrCodeId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!location) return null;

  const { fullAddress, city, country, latitude, longitude } = location

  const center: [number, number] = [
    latitude || 0,
    longitude || 0
  ];

  const maps_address = [fullAddress, city, country].filter(Boolean).join(", ")
  
  return (
    <div className="mt-3 d-flex flex-column justify-content-center align-items-center">
      <h2 className='text-white my-4 text-capitalize'>{fullAddress}, {city}, {country}</h2>
      <div style={{ width: '80%', height: '500px' }}>
        <MapContainer center={center} zoom={13} style={{ height: '100%', width: '100%' }}>
          <TileLayer
            attribution="&copy; OpenStreetMap contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={center}>
            <Popup>
            <div
              style={{ cursor: fullAddress ? "pointer" : "default", textDecoration:"underline" }}
              onClick={(e) => {
                if (!fullAddress) return;

                e.stopPropagation();
                window.open(
                  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(maps_address)}`,
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              {maps_address ?? "Indirizzo non disponibile"}
            </div>
          </Popup>
            
          </Marker>
        </MapContainer>
      </div>
    </div>
  );
}
